export default "__VITE_ASSET__ffa0514a__"